import { localeStringSchema } from "../locale";
const ActionTypes = {
  INIT: "INIT",
  CLEAN_UP: "CLEAN_UP",
  REGISTER_DOCUMENT: "REGISTER_DOCUMENT",
  UNREGISTER_DOCUMENT: "UNREGISTER_DOCUMENT",
  CHANGE_DOCUMENT: "CHANGE_DOCUMENT",
  CREATE_ELEMENT_TREE: "CREATE_ELEMENT_TREE",
  DELETE_ELEMENT_TREE: "DELETE_ELEMENT_TREE",
  CHANGE_ELEMENT_TREE: "CHANGE_ELEMENT_TREE",
  REGISTER_BUILDER_DOCUMENT: "REGISTER_BUILDER_DOCUMENT",
  UNREGISTER_BUILDER_DOCUMENT: "UNREGISTER_BUILDER_DOCUMENT",
  REGISTER_COMPONENT: "REGISTER_COMPONENT",
  UNREGISTER_COMPONENT: "UNREGISTER_COMPONENT",
  REGISTER_BUILDER_COMPONENT: "REGISTER_BUILDER_COMPONENT",
  UNREGISTER_BUILDER_COMPONENT: "UNREGISTER_BUILDER_COMPONENT",
  REGISTER_REACT_COMPONENT: "REGISTER_REACT_COMPONENT",
  UNREGISTER_REACT_COMPONENT: "UNREGISTER_REACT_COMPONENT",
  MOUNT_COMPONENT: "MOUNT_COMPONENT",
  UNMOUNT_COMPONENT: "UNMOUNT_COMPONENT",
  REGISTER_COMPONENT_HANDLE: "REGISTER_COMPONENT_HANDLE",
  UNREGISTER_COMPONENT_HANDLE: "UNREGISTER_COMPONENT_HANDLE",
  REGISTER_MEASURABLE: "REGISTER_MEASURABLE",
  UNREGISTER_MEASURABLE: "UNREGISTER_MEASURABLE",
  CHANGE_ELEMENT_BOX_MODELS: "CHANGE_ELEMENT_BOX_MODELS",
  CHANGE_DOCUMENT_ELEMENT_SIZE: "CHANGE_DOCUMENT_ELEMENT_SIZE",
  CHANGE_DOCUMENT_ELEMENT_SCROLL_TOP: "CHANGE_DOCUMENT_ELEMENT_SCROLL_TOP",
  SCROLL_DOCUMENT_ELEMENT: "SCROLL_DOCUMENT_ELEMENT",
  REGISTER_PROP_CONTROLLERS_HANDLE: "REGISTER_PROP_CONTROLLERS_HANDLE",
  UNREGISTER_PROP_CONTROLLERS_HANDLE: "UNREGISTER_PROP_CONTROLLERS_HANDLE",
  REGISTER_PROP_CONTROLLERS: "REGISTER_PROP_CONTROLLERS",
  UNREGISTER_PROP_CONTROLLERS: "UNREGISTER_PROP_CONTROLLERS",
  MESSAGE_HOST_PROP_CONTROLLER: "MESSAGE_HOST_PROP_CONTROLLER",
  MESSAGE_BUILDER_PROP_CONTROLLER: "MESSAGE_BUILDER_PROP_CONTROLLER",
  CHANGE_API_RESOURCE: "CHANGE_API_RESOURCE",
  EVICT_API_RESOURCE: "EVICT_API_RESOURCE",
  SET_IS_IN_BUILDER: "SET_IS_IN_BUILDER",
  HANDLE_WHEEL: "HANDLE_WHEEL",
  HANDLE_POINTER_MOVE: "HANDLE_POINTER_MOVE",
  API_RESOURCE_FULFILLED: "API_RESOURCE_FULFILLED",
  SET_BUILDER_EDIT_MODE: "SET_BUILDER_EDIT_MODE",
  MAKESWIFT_CONNECTION_INIT: "MAKESWIFT_CONNECTION_INIT",
  MAKESWIFT_CONNECTION_CHECK: "MAKESWIFT_CONNECTION_CHECK",
  BUILDER_POINTER_MOVE: "BUILDER_POINTER_MOVE",
  ELEMENT_FROM_POINT_CHANGE: "ELEMENT_FROM_POINT_CHANGE",
  SET_BREAKPOINTS: "SET_BREAKPOINTS",
  SET_LOCALE: "SET_LOCALE",
  SET_LOCALIZED_RESOURCE_ID: "SET_LOCALIZED_RESOURCE_ID",
  UPDATE_API_CLIENT_CACHE: "UPDATE_API_CLIENT_CACHE"
};
function init() {
  return { type: ActionTypes.INIT };
}
function cleanUp() {
  return { type: ActionTypes.CLEAN_UP };
}
function registerDocument(document) {
  return { type: ActionTypes.REGISTER_DOCUMENT, payload: { documentKey: document.key, document } };
}
function unregisterDocument(documentKey) {
  return { type: ActionTypes.UNREGISTER_DOCUMENT, payload: { documentKey } };
}
function createElementTree(payload) {
  return {
    type: ActionTypes.CREATE_ELEMENT_TREE,
    payload
  };
}
function deleteElementTree(payload) {
  return { type: ActionTypes.DELETE_ELEMENT_TREE, payload };
}
function changeElementTree(payload) {
  return {
    type: ActionTypes.CHANGE_ELEMENT_TREE,
    payload
  };
}
function registerBuilderDocument(document) {
  return {
    type: ActionTypes.REGISTER_BUILDER_DOCUMENT,
    payload: { documentKey: document.key, document }
  };
}
function unregisterBuilderDocument(documentKey) {
  return { type: ActionTypes.UNREGISTER_BUILDER_DOCUMENT, payload: { documentKey } };
}
function registerDocumentsEffect(documents) {
  return (dispatch) => {
    documents.forEach((document) => dispatch(registerDocument(document)));
    return () => {
      documents.forEach((document) => dispatch(unregisterDocument(document.key)));
    };
  };
}
function registerBuilderDocumentsEffect(documents) {
  return (dispatch) => {
    documents.forEach((document) => dispatch(registerBuilderDocument(document)));
    return () => {
      documents.forEach((document) => dispatch(unregisterBuilderDocument(document.key)));
    };
  };
}
function changeDocument(documentKey, operation) {
  return { type: ActionTypes.CHANGE_DOCUMENT, payload: { documentKey, operation } };
}
function registerComponent(type, meta, propControllerDescriptors) {
  return {
    type: ActionTypes.REGISTER_COMPONENT,
    payload: { type, meta, propControllerDescriptors }
  };
}
function unregisterComponent(type) {
  return { type: ActionTypes.UNREGISTER_COMPONENT, payload: { type } };
}
function registerComponentEffect(type, meta, propControllerDescriptors) {
  return (dispatch) => {
    dispatch(registerComponent(type, meta, propControllerDescriptors));
    return () => {
      dispatch(unregisterComponent(type));
    };
  };
}
function registerBuilderComponent(payload, transferables) {
  return {
    type: ActionTypes.REGISTER_BUILDER_COMPONENT,
    payload,
    transferables
  };
}
function unregisterBuilderComponent(payload) {
  return { type: ActionTypes.UNREGISTER_BUILDER_COMPONENT, payload };
}
function registerReactComponent(type, component) {
  return { type: ActionTypes.REGISTER_REACT_COMPONENT, payload: { type, component } };
}
function unregisterReactComponent(type) {
  return { type: ActionTypes.UNREGISTER_REACT_COMPONENT, payload: { type } };
}
function registerReactComponentEffect(type, component) {
  return (dispatch) => {
    dispatch(registerReactComponent(type, component));
    return () => {
      dispatch(unregisterReactComponent(type));
    };
  };
}
function mountComponent(documentKey, elementKey) {
  return { type: ActionTypes.MOUNT_COMPONENT, payload: { documentKey, elementKey } };
}
function unmountComponent(documentKey, elementKey) {
  return { type: ActionTypes.UNMOUNT_COMPONENT, payload: { documentKey, elementKey } };
}
function mountComponentEffect(documentKey, elementKey) {
  return (dispatch) => {
    dispatch(mountComponent(documentKey, elementKey));
    return () => {
      dispatch(unmountComponent(documentKey, elementKey));
    };
  };
}
function registerComponentHandle(documentKey, elementKey, componentHandle) {
  return {
    type: ActionTypes.REGISTER_COMPONENT_HANDLE,
    payload: { documentKey, elementKey, componentHandle }
  };
}
function unregisterComponentHandle(documentKey, elementKey) {
  return { type: ActionTypes.UNREGISTER_COMPONENT_HANDLE, payload: { documentKey, elementKey } };
}
function registerComponentHandleEffect(documentKey, elementKey, componentHandle) {
  return (dispatch) => {
    dispatch(registerComponentHandle(documentKey, elementKey, componentHandle));
    return () => {
      dispatch(unregisterComponentHandle(documentKey, elementKey));
    };
  };
}
function registerMeasurable(documentKey, elementKey, measurable) {
  return { type: ActionTypes.REGISTER_MEASURABLE, payload: { documentKey, elementKey, measurable } };
}
function unregisterMeasurable(documentKey, elementKey) {
  return { type: ActionTypes.UNREGISTER_MEASURABLE, payload: { documentKey, elementKey } };
}
function registerMeasurableEffect(documentKey, elementKey, measurable) {
  return (dispatch) => {
    dispatch(registerMeasurable(documentKey, elementKey, measurable));
    return () => {
      dispatch(unregisterMeasurable(documentKey, elementKey));
    };
  };
}
function changeElementBoxModels(changedElementBoxModels) {
  return { type: ActionTypes.CHANGE_ELEMENT_BOX_MODELS, payload: { changedElementBoxModels } };
}
function changeDocumentElementSize(size) {
  return { type: ActionTypes.CHANGE_DOCUMENT_ELEMENT_SIZE, payload: { size } };
}
function changeDocumentElementScrollTop(scrollTop) {
  return { type: ActionTypes.CHANGE_DOCUMENT_ELEMENT_SCROLL_TOP, payload: { scrollTop } };
}
function scrollDocumentElement(scrollTopDelta) {
  return { type: ActionTypes.SCROLL_DOCUMENT_ELEMENT, payload: { scrollTopDelta } };
}
function registerPropControllersHandle(documentKey, elementKey, handle) {
  return {
    type: ActionTypes.REGISTER_PROP_CONTROLLERS_HANDLE,
    payload: { documentKey, elementKey, handle }
  };
}
function unregisterPropControllersHandle(documentKey, elementKey) {
  return {
    type: ActionTypes.UNREGISTER_PROP_CONTROLLERS_HANDLE,
    payload: { documentKey, elementKey }
  };
}
function registerPropControllers(documentKey, elementKey, propControllers) {
  return {
    type: ActionTypes.REGISTER_PROP_CONTROLLERS,
    payload: { documentKey, elementKey, propControllers }
  };
}
function unregisterPropControllers(documentKey, elementKey) {
  return { type: ActionTypes.UNREGISTER_PROP_CONTROLLERS, payload: { documentKey, elementKey } };
}
function messageHostPropController(documentKey, elementKey, propName, message) {
  return {
    type: ActionTypes.MESSAGE_HOST_PROP_CONTROLLER,
    payload: { documentKey, elementKey, propName, message }
  };
}
function messageBuilderPropController(documentKey, elementKey, propName, message) {
  return {
    type: ActionTypes.MESSAGE_BUILDER_PROP_CONTROLLER,
    payload: { documentKey, elementKey, propName, message }
  };
}
function changeApiResource(resource, locale) {
  return { type: ActionTypes.CHANGE_API_RESOURCE, payload: { resource, locale } };
}
function evictApiResource(id, locale) {
  return { type: ActionTypes.EVICT_API_RESOURCE, payload: { id, locale } };
}
function setIsInBuilder(isInBuilder) {
  return { type: ActionTypes.SET_IS_IN_BUILDER, payload: isInBuilder };
}
function handleWheel(payload) {
  return { type: ActionTypes.HANDLE_WHEEL, payload };
}
function handlePointerMove(payload) {
  return { type: ActionTypes.HANDLE_POINTER_MOVE, payload };
}
function apiResourceFulfilled(resourceType, resourceId, resource, locale) {
  return {
    type: ActionTypes.API_RESOURCE_FULFILLED,
    payload: { resourceType, resourceId, resource, locale }
  };
}
function setBuilderEditMode(editMode) {
  return {
    type: ActionTypes.SET_BUILDER_EDIT_MODE,
    payload: { editMode }
  };
}
function builderPointerMove(pointer) {
  return { type: ActionTypes.BUILDER_POINTER_MOVE, payload: { pointer } };
}
function elementFromPointChange(keys) {
  return { type: ActionTypes.ELEMENT_FROM_POINT_CHANGE, payload: { keys } };
}
function setBreakpoints(breakpoints) {
  return { type: ActionTypes.SET_BREAKPOINTS, payload: { breakpoints } };
}
function setLocale(locale, pathname) {
  return {
    type: ActionTypes.SET_LOCALE,
    payload: { locale: localeStringSchema.parse(locale.toString()), pathname }
  };
}
function setLocalizedResourceId({
  resourceId,
  localizedResourceId,
  locale
}) {
  return {
    type: ActionTypes.SET_LOCALIZED_RESOURCE_ID,
    payload: { resourceId, localizedResourceId, locale }
  };
}
function updateAPIClientCache(payload) {
  return { type: ActionTypes.UPDATE_API_CLIENT_CACHE, payload };
}
export {
  ActionTypes,
  apiResourceFulfilled,
  builderPointerMove,
  changeApiResource,
  changeDocument,
  changeDocumentElementScrollTop,
  changeDocumentElementSize,
  changeElementBoxModels,
  changeElementTree,
  cleanUp,
  createElementTree,
  deleteElementTree,
  elementFromPointChange,
  evictApiResource,
  handlePointerMove,
  handleWheel,
  init,
  messageBuilderPropController,
  messageHostPropController,
  mountComponent,
  mountComponentEffect,
  registerBuilderComponent,
  registerBuilderDocument,
  registerBuilderDocumentsEffect,
  registerComponent,
  registerComponentEffect,
  registerComponentHandle,
  registerComponentHandleEffect,
  registerDocument,
  registerDocumentsEffect,
  registerMeasurable,
  registerMeasurableEffect,
  registerPropControllers,
  registerPropControllersHandle,
  registerReactComponentEffect,
  scrollDocumentElement,
  setBreakpoints,
  setBuilderEditMode,
  setIsInBuilder,
  setLocale,
  setLocalizedResourceId,
  unmountComponent,
  unregisterBuilderComponent,
  unregisterBuilderDocument,
  unregisterComponent,
  unregisterDocument,
  unregisterMeasurable,
  unregisterPropControllers,
  unregisterPropControllersHandle,
  updateAPIClientCache
};
//# sourceMappingURL=actions.js.map